import React from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-32 px-6 bg-charcoal-light relative border-t border-gold/10 overflow-hidden" data-id="element-148">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-gold-muted rounded-full blur-[150px] opacity-10 pointer-events-none translate-x-1/3 -translate-y-1/3" data-id="element-149" />

      <div className="max-w-6xl mx-auto" data-id="element-150">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24" data-id="element-151">
          {/* Left: Mockup Placeholder */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="w-full lg:w-1/2 flex justify-center" data-id="element-152">
            <div className="relative w-full max-w-md group" data-id="element-153">
              {/* Glow behind the book */}
              <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full opacity-40 group-hover:opacity-60 transition-opacity duration-700" data-id="element-154" />

              {/* The Book Cover Image */}
              <img src="https://cdn.magicpatterns.com/uploads/qix5QrNzpRmt5i52T5a9q7/PORTADA_EBOOK_RUPTURA.png" alt="Portada del ebook Código Post-Ruptura" className="relative w-full h-auto rounded-sm shadow-2xl transition-transform duration-700 group-hover:scale-[1.03]" data-id="element-155" />
            </div>
          </motion.div>

          {/* Right: Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="w-full lg:w-1/2" data-id="element-156">
            <h2 className="font-playfair text-4xl md:text-5xl text-white leading-tight mb-8" data-id="element-157">
              No es amor, es una{' '}
              <span className="text-gold italic" data-id="element-158">adicción química.</span>
            </h2>

            <div className="space-y-6 font-sans text-lg text-gray-400 font-light leading-relaxed" data-id="element-159">
              <p data-id="element-160">
                Tu cerebro está experimentando un síndrome de abstinencia real.
                Cada vez que revisas su perfil o esperas un mensaje, estás
                alimentando el ciclo de dependencia.
              </p>
              <p data-id="element-161">
                La fuerza de voluntad no es suficiente cuando luchas contra tu
                propia biología. Necesitas un sistema.
              </p>
              <p className="text-white font-medium text-xl border-l-2 border-gold pl-6 py-2 mt-8" data-id="element-162">
                Este Código es tu desintoxicación táctica.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}